
// src/store/modules/account.js
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import {
    API_FORGETCODE_INFO,
    APP_FORGETCODE_FAILURE
} from '../../../config/mutation-types'

import {
    API_AI
} from '../../../config/const'


const state = {
    apiInfo: ''
}

const getters = {
    getForgetCode: state => state.apiInfo
}

const actions = {
    getForgetCode({commit}, options) {
        var uri = API_AI + "/h5/auth/sendForgetPwdCaptcha/" + options.data.mobile
        return new Promise((resolve, reject) => {
            Vue.http.get(uri).then((res, err) => {
                    resolve(res.data)
                }, (res) => {
                    reject(res.data)
                })
            }).then((res) => {
                commit(API_FORGETCODE_INFO, res)
            }, (err) => {
                commit(APP_FORGETCODE_FAILURE, err + '获取信息失败')
            })
    }
}

const mutations = {
    [API_FORGETCODE_INFO](state, data) {
        state.apiInfo = data
    },
    [APP_FORGETCODE_FAILURE](state, data) {
        state.apiInfo = data
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/login/forgetCode.js